import React, { useState, useEffect, useRef } from 'react'
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { Table } from "antd";
import Cookies from "js-cookie";
import Select from "react-select";
import { useDispatch, useSelector } from 'react-redux';
// import { getPickedRateReqList } from '../../../Redux/action/Sales/PickedRateRequestAction';
import { toast } from 'react-toastify';
// import Beatloader from '../../../Common/Loaders/Beatloader';
import { useFormik } from 'formik';
// import ReactPaginate from 'react-paginate';
import { getPickedRateReqList } from '../../../Redux/action/Sales/PickedRateRequestAction';
// import { getPickedRateReqList } from '../../../Redux/action/Sales/PickedRateRequestAction';

// import ReactPaginate from 'react-paginate';

const InprocessPickedList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    let [list, setList] = useState([]);
    const [currentPage, setCurrentPage] = useState(null); // Pages are 1-indexed
    const [totalPages, setTotalPages] = useState(0);
    const [query, setQuery] = useState("");
    const [totalItems, setTotalItems] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    function capitalizeText(text) {
        return text.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
    }

    function formatDate(dateString) {
        if (dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        } else {
            return "";
        }
    }

    const headers = [
        'REQUEST NO.',
        'Date',
        'NAME',
        'EMAIL',
        'PHONE NUMBER',
        'ORIGIN',
        'DESTINATION',
        'SHIPMENT TYPE',
        'SHIPMENT VIA',
        // 'REQUIRED SERVICE',
        'PICKED BY',
        'actions',
    ];

    const tableRef = useRef(null);
    const [isGrabbing, setIsGrabbing] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);


    //for mouse events
    const handleMouseDown = (e) => {
        const slider = tableRef.current;
        setIsGrabbing(true);
        slider.classList.add('grabbing'); // Apply grabbing CSS class
        setStartX(e.pageX - slider.offsetLeft);
        setScrollLeft(slider.scrollLeft);
    };

    const handleMouseUp = () => {
        const slider = tableRef.current;
        setIsGrabbing(false);
        slider.classList.remove('grabbing'); // Remove grabbing CSS class
    };

    const handleMouseMove = (e) => {
        if (!isGrabbing) return;
        e.preventDefault();
        const slider = tableRef.current;
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2; // Speed of scroll
        slider.scrollLeft = scrollLeft - walk;
    };


    const token = Cookies.get('token');
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;

    const queryParams = new URLSearchParams(location.search);
    const queryString = new URLSearchParams(location.search).toString();
    useEffect(() => {
        setQuery(queryString);
        // dispatch(getPickedRateReqList(token, "INPROCESS", queryParams.get("page") ?? 1, queryString))
    }, [queryParams])

    useEffect(() => {
        dispatch(getPickedRateReqList(token, "INPROCESS", queryParams.get("page") ?? 1, queryString))
    }, [query])


    useEffect(() => {
        if (!token) {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        } else {
            // dispatch(getPickedRateReqList(token, currentModule, currentPage));
        }
    }, []);

    let { loadingPickedRateReqListApi, pickedRateReqListDataError, pickedRateReqListData, pickedRateReqListCurrentPage, pickedRateReqListTotalPage, pickedRateReqListTotalData } = useSelector(state => state?.PickedRateRequestReducer);


    useEffect(() => {

        if (pickedRateReqListData) {
            setList(pickedRateReqListData);
        }

        if (pickedRateReqListCurrentPage) {
            setCurrentPage(pickedRateReqListCurrentPage);
        }

        if (pickedRateReqListTotalData) {
            setTotalItems(pickedRateReqListTotalData);
        }

        if (pickedRateReqListTotalPage) {
            setTotalPages(pickedRateReqListTotalPage);
        }
    }, [loadingPickedRateReqListApi, pickedRateReqListDataError, pickedRateReqListData, pickedRateReqListCurrentPage, pickedRateReqListTotalPage, pickedRateReqListTotalData])




    const handlePageClick = (selectedObject) => {
        const selectedPage = selectedObject.selected + 1;
        const params = new URLSearchParams(location.search);
        params.set("page", selectedPage);
        navigate(`?${params.toString()}`);
    };
    //search and filter data
    const parseQueryParams = () => {
        const params = new URLSearchParams(location.search);
        return {
            search_by: params.get("search_by") || "",
            request_no: params.get("request_no") || "",
            name: params.get("name") || "",
            email: params.get("email") || "",
            phone: params.get("phone") || "",
            origin: params.get("origin") || "",
            destination: params.get("destination") || "",
            shipment_type_id: params.get("shipment_type_id") || "",
            shipment_via_id: params.get("shipment_via_id") || "",
            required_servie_id: params.get("required_servie_id") || "",
            start_date: params.get("start_date") || "",
            end_date: params.get("end_date") || "",
            quotation_date: params.get("quotation_date") || "",
            filter_by: params.get("filter_by") || ""
        };
    };

    let formik = useFormik({
        initialValues: parseQueryParams(),
        onSubmit: (values) => {
            const params = new URLSearchParams(location.search);
            Object.keys(values).forEach((key) => {
                if (values[key]) {
                    params.set(key, values[key]);
                } else {
                    params.delete(key);
                }
            });

            if (!params.has("page")) {
                params.set("page", "1");
            } else {
                params.set("page", "1");
            }
            const queryString = params.toString();
            navigate(`${location.pathname}?${queryString}`);
            const currentPage = 1;
            const ITEMS_PER_PAGE = 10;
            dispatch(getPickedRateReqList(token, "INPROCESS", currentPage, queryString));
        },
    });

    const resetFilters = () => {
        try {
            formik.setValues({
                search_by: "",
                request_no: "",
                name: "",
                email: "",
                phone: "",
                origin: "",
                destination: "",
                shipment_type_id: "",
                shipment_via_id: "",
                required_servie_id: "",
                start_date: "",
                end_date: "",
                quotation_date: "",
                filter_by: "",
            });
            navigate(`/flexichain/picked-rate-request-list-inprocess`)
        } catch (error) {
            console.log(error.message);
            toast.error("Some error occured!");
        }
    };

    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys)
    }
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange
    }
    const columns = [
        { title: "Request No.", dataIndex: "requestNo", key: "requestNo" },
        { title: "Date", dataIndex: "date", key: "date" },
        { title: "Name", dataIndex: "name", key: "name" },
        { title: "Email", dataIndex: "email", key: "email" },
        { title: "Phone Number", dataIndex: "phoneNumber", key: "phoneNumber" },
        { title: "Origin", dataIndex: "origin", key: "origin" },
        { title: "Destination", dataIndex: "destination", key: "destination" },
        { title: "Shipment Type", dataIndex: "shipmentType", key: "shipmentType" },
        { title: "Shipment Via", dataIndex: "shipmentVia", key: "shipmentVia" },
        { title: "Picked By", dataIndex: "pickedBy", key: "pickedBy" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];
    const dataSource = list?.map((value, i) => ({
        key: i, // Add a unique key for each row
        requestNo: value?.request_no, // Changed to camelCase
        date: formatDate(value?.createdAt), // Ensure date formatting as needed
        name: (
            <h2 className="d-flex align-items-center">
                <Link to="#" className="avatar avatar-sm me-2">
                    <img className="img-fluid" src="/assets/img/profiles/avatar-19.jpg" alt="avatar" />
                </Link>
                <Link to="#" className="d-flex flex-column">
                    <span className="text-default">{value?.full_name}</span>
                </Link>
            </h2>
        ),
        email: value?.email, // Make sure to use the correct data field for email
        phoneNumber: value?.phone, // Correct data field for phone number
        origin: value?.origin, // Correct data field for origin
        destination: value?.destination, // Correct data field for destination
        shipmentType: value?.shipment_type?.name, // Correct field for shipment type
        shipmentVia: value?.shipment_via?.name, // Correct field for shipment via
        pickedBy: value?.picked_by ? value?.picked_by : "Empty", // Correct field for picked by
        action: (
            <div className="dropdown table-action">
                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                    <i className="fa fa-ellipsis-v"></i>
                </Link>
                <div className="dropdown-menu dropdown-menu-right">
                    {/* <Link className="dropdown-item" to="#" onClick={() => {

                    }} data-bs-toggle="offcanvas" data-bs-target="#offcanvas_edit_form">
                        <i className="ti ti-edit text-blue"></i> Edit
                    </Link>
                    <Link className="dropdown-item" to="#" data-bs-toggle="modal" data-bs-target="#delete_contact">
                        <i className="ti ti-trash text-danger"></i> Delete
                    </Link> */}
                    <div className="dropdown-item" onClick={() => { navigate('/flexichain/query-import-give-rates', { state: { quotationId: value.id } }) }}>
                        <i className="ti ti-eye text-blue-light"></i> Preview
                    </div>
                </div>
            </div>
        ),
    }));
    const [grid, setGrid] = useState(true)
    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">
                                            RePricing List <span className="count-title">{pickedRateReqListTotalData}</span>
                                        </h4>
                                    </div>
                                    <div className="col-4 text-end">
                                        <div className="head-icons">
                                            {/* <a
                                                href="contacts.html"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                data-bs-original-title="Refresh"
                                            >
                                                <i className="ti ti-refresh-dot" />
                                            </a> */}
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                data-bs-original-title="Collapse"
                                                id="collapse-header"
                                            >
                                                <i className="ti ti-chevrons-up" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Page Header */}
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-header">
                            {/* Search */}
                            <form onSubmit={formik.handleSubmit}>
                                <div className="row align-items-center">
                                    <div className="col-sm-4">
                                        <div className="icon-form mb-3 mb-sm-0">
                                            <span className="form-icon">
                                                <i className="ti ti-search" />
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search"
                                                name='search_by'
                                                value={formik.values.search_by}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-8">

                                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                                            <button type='submit' className="btn btn-primary me-2">
                                                Search
                                            </button>
                                            <button
                                                className='btn btn-primary me-2'
                                                //   style={{ background: "#04aed2", marginTop: "7px", marginBottom: "15px" }}
                                                onClick={resetFilters}
                                            >
                                                Clear
                                            </button>
                                            {/* <div className="dropdown me-2">
                                            <a
                                                href="javascript:void(0);"
                                                className="dropdown-toggle"
                                                data-bs-toggle="dropdown"
                                            >
                                                <i className="ti ti-package-export me-2" />
                                                Export
                                            </a>
                                            <div className="dropdown-menu  dropdown-menu-end">
                                                <ul>
                                                    <li>
                                                        <a href="javascript:void(0);" className="dropdown-item">
                                                            <i className="ti ti-file-type-pdf text-danger me-1" />
                                                            Export as PDF
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:void(0);" className="dropdown-item">
                                                            <i className="ti ti-file-type-xls text-green me-1" />
                                                            Export as Excel{" "}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div> */}
                                            {/* <a
                                                href="javascript:void(0);"
                                                className="btn btn-primary"
                                                data-bs-toggle="offcanvas"
                                                data-bs-target="#offcanvas_create"
                                            >
                                                <i className="ti ti-square-rounded-plus me-2" />
                                                Create Quote
                                            </a> */}
                                        </div>
                                    </div>
                                </div>
                            </form>
                            {/* /Search */}
                        </div>
                        <div className="card-body">
                            {/* Filter */}
                            <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                    <div className="dropdown me-2">
                                        <a
                                            href="javascript:void(0);"
                                            className="dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                        >
                                            <i className="ti ti-sort-ascending-2 me-2" />
                                            Sort{" "}
                                        </a>
                                        <div className="dropdown-menu  dropdown-menu-start">
                                            <ul>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Ascending
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Descending
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Recently Viewed
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Recently Added
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="icon-form">
                                        <span className="form-icon">
                                            <i className="ti ti-calendar" />
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control bookingrange"
                                            placeholder=""
                                        />
                                    </div>
                                </div>
                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                    {/* <div className="dropdown me-2">
                                        <a
                                            href="javascript:void(0);"
                                            className="btn bg-soft-purple text-purple"
                                            data-bs-toggle="dropdown"
                                            data-bs-auto-close="outside"
                                        >
                                            <i className="ti ti-columns-3 me-2" />
                                            Manage Columns
                                        </a>
                                        <div className="dropdown-menu  dropdown-menu-md-end dropdown-md p-3">
                                            <h4 className="mb-2 fw-semibold">Want to manage datatables?</h4>
                                            <p className="mb-3">
                                                Please drag and drop your column to reorder your table and
                                                enable see option as you want.
                                            </p>
                                            <div className="border-top pt-3">
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Name
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-name" className="check" />
                                                        <label htmlFor="col-name" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Phone
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-phone" className="check" />
                                                        <label htmlFor="col-phone" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Email
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-email" className="check" />
                                                        <label htmlFor="col-email" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Tags
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-tag" className="check" />
                                                        <label htmlFor="col-tag" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Location
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-loc" className="check" />
                                                        <label htmlFor="col-loc" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Rating
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-rate" className="check" />
                                                        <label htmlFor="col-rate" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Owner
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-owner" className="check" />
                                                        <label htmlFor="col-owner" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Contact
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input
                                                            type="checkbox"
                                                            id="col-contact"
                                                            className="check"
                                                            defaultChecked=""
                                                        />
                                                        <label htmlFor="col-contact" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Status
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input
                                                            type="checkbox"
                                                            id="col-status"
                                                            className="check"
                                                        />
                                                        <label htmlFor="col-status" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Action
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input
                                                            type="checkbox"
                                                            id="col-action"
                                                            className="check"
                                                        />
                                                        <label htmlFor="col-action" className="checktoggle" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="form-sorts dropdown me-2">
                                        <a
                                            href="javascript:void(0);"
                                            data-bs-toggle="dropdown"
                                            data-bs-auto-close="outside"
                                        >
                                            <i className="ti ti-filter-share" />
                                            Filter
                                        </a>
                                        <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end p-3">
                                            <div className="filter-set-view">
                                                <div className="filter-set-head">
                                                    <h4>
                                                        <i className="ti ti-filter-share" />
                                                        Filter
                                                    </h4>
                                                </div>
                                                <table className="content-table">
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">REQUEST NO.</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Request No."
                                                                    name="request_no"
                                                                    value={formik.values.request_no}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">NAME</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Name"
                                                                    name="name"
                                                                    value={formik.values.name}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">EMAIL</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Email"
                                                                    name="email"
                                                                    value={formik.values.email}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">PHONE NUMBER</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Number"
                                                                    name="phone"
                                                                    value={formik.values.phone}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">ORIGIN</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Origin"
                                                                    name="origin"
                                                                    value={formik.values.origin}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">DESTINATION</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Destination"
                                                                    name="destination"
                                                                    value={formik.values.destination}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">SHIPMENT TYPE</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Shipment Type"
                                                                    name="shipment_type_id"
                                                                    value={formik.values.shipment_type_id}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">SHIPMENT VIA</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Shipment Via"
                                                                    name="shipment_via_id"
                                                                    value={formik.values.shipment_via_id}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">REQUIRED SERVICE</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Required Service"
                                                                    name="required_servie_id"
                                                                    value={formik.values.required_servie_id}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            </td>
                                                        </tr>
                                                        {/* <tr>
                                    <td>
                                      <label htmlFor="#">PICKED BY</label>
                                    </td>
                                    <td className="input_box_filter">
                                      {" "}
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Picked By"
                                        value={formik.values.picked_user}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                      />
                                    </td>
                                  </tr> */}
                                                    </tbody>
                                                </table>


                                                <div className="filter-reset-btns">
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <a onClick={resetFilters} className="btn btn-light">
                                                                Reset
                                                            </a>
                                                        </div>
                                                        <div className="col-6">
                                                            <a type='submit' className="btn btn-primary">
                                                                Apply
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="view-icons">
                                        <Link onClick={() => { setGrid(true) }} className={`${grid === true && "active"}`}>
                                            <i className="ti ti-list-tree" />
                                        </Link>
                                        <Link onClick={() => { setGrid(false) }} className={`${grid === false && "active"}`}>
                                            <i className="ti ti-grid-dots" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            {/* /Filter */}
                            {/* Contact List */}
                            <div className='' style={{ width: "auto", overflowX: "auto", overflowY: "hidden", scrollBehavior: "smooth" }}>
                                <ul className="nav mx-1 nav-pills nav-slider my-2 border-2 custom-tabs" id="pills-tab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button onClick={() => { navigate("/flexichain/import-picked-rate-request") }} id="pills-rebid-tab" data-bs-toggle="pill" data-bs-target="#pills-rebid" type="button" role="tab" aria-controls="pills-rebid" aria-selected="true" className={`nav-link fw-semibold custom-tab   position-relative`} >Repricing <span className="tab-count">{list?.length}</span></button>
                                    </li>

                                    <li className="nav-item" role="presentation">
                                        <button onClick={() => { navigate(`/flexichain/picked-rate-request-list-inprocess`) }} id="pills-send-process" data-bs-toggle="pill" data-bs-target="#pills-rebid" type="button" role="tab" aria-controls="pills-rebid" aria-selected="false" className={`nav-link  fw-semibold active custom-tab  position-relative`} >In Process <span className="tab-count">{pickedRateReqListTotalData}</span></button>
                                    </li>
                                </ul>

                            </div>
                            {
                                grid ? <div className="table-responsive custom-table">
                                    <Table className="table datanew dataTable no-footer" pagination={false}
                                        rowSelection={rowSelection} dataSource={dataSource} columns={columns} />
                                </div> :
                                    <div className='row'>
                                        {
                                            list?.data?.length > 0 ?
                                                list?.data?.map((value, i) => {
                                                    return (
                                                        <div key={i} className="col-xxl-3 col-xl-4 col-md-6">
                                                            <div className="card border">
                                                                <div className="card-body">
                                                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                                                        <div className="d-flex align-items-center">
                                                                            <a
                                                                                href="contact-details.html"
                                                                                className="avatar avatar-md flex-shrink-0 me-2"
                                                                            >
                                                                                <img
                                                                                    src="/assets/img/profiles/avatar-19.jpg"
                                                                                    alt="img"
                                                                                />
                                                                            </a>
                                                                            <div>
                                                                                <h6>
                                                                                    <a
                                                                                        href="contact-details.html"
                                                                                        className="fw-medium"
                                                                                    >
                                                                                        {value?.full_name}
                                                                                    </a>
                                                                                </h6>
                                                                                <p className="text-default">{value?.quotation_user_type}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="dropdown table-action">
                                                                            <a
                                                                                href="#"
                                                                                className="action-icon "
                                                                                data-bs-toggle="dropdown"
                                                                                aria-expanded="false"
                                                                            >
                                                                                <i className="fa fa-ellipsis-v" />
                                                                            </a>
                                                                            <div className="dropdown-menu dropdown-menu-right">
                                                                                {/* <Link className="dropdown-item" to="#" onClick={() => {

                    }} data-bs-toggle="offcanvas" data-bs-target="#offcanvas_edit_form">
                        <i className="ti ti-edit text-blue"></i> Edit
                    </Link>
                    <Link className="dropdown-item" to="#" data-bs-toggle="modal" data-bs-target="#delete_contact">
                        <i className="ti ti-trash text-danger"></i> Delete
                    </Link> */}
                                                                                <div className="dropdown-item" onClick={() => { navigate('/flexichain/query-import-give-rates', { state: { quotationId: value.id } }) }}>
                                                                                    <i className="ti ti-eye text-blue-light"></i> Preview
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-block">
                                                                        <div className="d-flex flex-column mb-3">
                                                                            <p className="text-default d-inline-flex align-items-center mb-2">
                                                                                <i className="ti ti-mail text-dark me-1" />
                                                                                {value?.email}
                                                                            </p>
                                                                            <p className="text-default d-inline-flex align-items-center mb-2">
                                                                                <i className="ti ti-phone text-dark me-1" />
                                                                                {value?.phone}
                                                                            </p>
                                                                            <p className="text-default d-inline-flex align-items-center">
                                                                                <i className="ti ti-map-pin-pin text-dark me-1" />
                                                                                {value?.origin_type == "AIRPORT" ? "Mumbai, India" : `${value?.destination_address}, ${value?.destination_city ? value?.destination_city?.name : ""}, ${value?.destination_state ? value?.destination_state?.name : ""}, ${value?.destination_country ? value?.destination_country?.name : ""} `}
                                                                            </p>
                                                                        </div>
                                                                        <div className="d-flex align-items-center">
                                                                            <span className="badge badge-tag badge-success-light me-2">
                                                                                {value?.quote_status?.name}
                                                                            </span>
                                                                            {/* <span className="badge badge-tag badge-warning-light">
                                                                                    Rated
                                                                                </span> */}
                                                                        </div>
                                                                    </div>
                                                                    {/* <div className="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
                                                                            <div className="d-flex align-items-center grid-social-links">
                                                                                <a
                                                                                    href="#"
                                                                                    className="avatar avatar-xs text-dark rounded-circle me-1"
                                                                                >
                                                                                    <i className="ti ti-mail fs-14" />
                                                                                </a>
                                                                                <a
                                                                                    href="#"
                                                                                    className="avatar avatar-xs text-dark rounded-circle me-1"
                                                                                >
                                                                                    <i className="ti ti-phone-check fs-14" />
                                                                                </a>
                                                                                <a
                                                                                    href="#"
                                                                                    className="avatar avatar-xs text-dark rounded-circle me-1"
                                                                                >
                                                                                    <i className="ti ti-message-circle-share fs-14" />
                                                                                </a>
                                                                                <a
                                                                                    href="#"
                                                                                    className="avatar avatar-xs text-dark rounded-circle me-1"
                                                                                >
                                                                                    <i className="ti ti-brand-skype fs-14" />
                                                                                </a>
                                                                                <a
                                                                                    href="#"
                                                                                    className="avatar avatar-xs text-dark rounded-circle"
                                                                                >
                                                                                    <i className="ti ti-brand-facebook fs-14" />
                                                                                </a>
                                                                            </div>
                                                                            <div className="d-flex align-items-center">
                                                                                <div className="set-star text-default me-2">
                                                                                    <i className="fa fa-star filled me-1" />
                                                                                    4.2
                                                                                </div>
                                                                                <a
                                                                                    href="javascript:void(0);"
                                                                                    className="avatar avatar-md"
                                                                                    data-bs-toggle="tooltip"
                                                                                    data-bs-original-title="Mervin"
                                                                                    data-bs-placement="top"
                                                                                >
                                                                                    <img
                                                                                        src="/assets/img/profiles/avatar-14.jpg"
                                                                                        alt="img"
                                                                                    />
                                                                                </a>
                                                                            </div>
                                                                        </div> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                }) :
                                                <div className="box-grid">
                                                    No data available
                                                </div>
                                        }
                                    </div>
                            }
                            <div className="row align-items-center">
                                <div className="col-md-6">
                                    <div className="datatable-length" />
                                </div>
                                <div className="col-md-6">
                                    <div className="datatable-paginate" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <EditEmployee id="offcanvas_edit" />
            <AddEmployee id="offcanvas_add" /> */}
            {/* <CreateQuoteForm fetchQuotations={fetchQuotations} id="offcanvas_create" />

            <EditQuoteForm id="offcanvas_edit_form" QuotationId={id} ViewDetails={viewData} /> */}
        </>

    )
}

export default InprocessPickedList